import { ColoursObj, Icon } from "@eventr/common-storybook";
import { FileList } from "./fileList";
import { RowInfo } from "./rowInfo";
interface RowInfoFilesProps {
  files: string[];
  type?: "card" | "page";
}

export const RowInfoFiles = ({ files, type }: RowInfoFilesProps) => {
  if (typeof files !== "object") return null;
  if (!files) return null;
  if (files.length === 0) return null;

  if (type === "page") {
    return (
      <RowInfo
        start={<Icon name="Attach" iconColour={ColoursObj.coreBrights.primary} />}
        middle={<FileList files={files} />}
      />
    );
  }

  return (
    <RowInfo
      start={<Icon name="Attach" bubble bubbleColour={ColoursObj.coreBrights.primary} />}
      middle={<FileList files={files} />}
    />
  );
};
